import { render, staticRenderFns } from "./BdssfReportClientele.vue?vue&type=template&id=4bd3b34b&scoped=true&"
import script from "./BdssfReportClientele.vue?vue&type=script&lang=js&"
export * from "./BdssfReportClientele.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3b34b",
  null
  
)

export default component.exports